export const DESKTOP_WIDTH = 1200;
export const DESKTOP_HEIGHT = 600;
// note: users should be able to set this on their own in the future
export const MESSAGES_PER_BATCH = 30;
